import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import bgColorsImage from '@/images/bg_colors.webp';
import bgPatternImage from '@/images/bg_pattern.webp';
import { SITE_NAME } from '@/config';

import { useShowCurrencySelector } from '@/hooks';
import { usePlans } from '@/hooks/price';
import { useMedia } from '@/hooks/responsive';
import PlanCardUnified from '@/components/PlanCardUnified';

export function Hero() {
	const { t } = useTranslation();
	const showCurrencySelector = useShowCurrencySelector();
	const plansData = usePlans();

	const mdDown = useMedia('mdDown');

	return (
		<Box
			component="section"
			bgcolor="#FFF"
			position="relative"
			py={[6, 6, 12]}
			sx={{
				overflowX: 'hidden'
			}}
		>
			<Box
				height={{ xs: 300, md: 480 }}
				left={{ xs: '-35%', md: 0 }}
				position="absolute"
				right={{ xs: '-35%', md: 0 }}
				top={0}
				zIndex={0}
				sx={{
					backgroundImage: `url('${bgColorsImage}')`,
					backgroundPosition: 'center',
					backgroundSize: 'cover'
				}}
			>
				<Box
					sx={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundImage: `url('${bgPatternImage}')`,
						backgroundPosition: 'bottom',
						backgroundRepeat: 'repeat-x'
					}}
				/>
			</Box>
			<Container
				maxWidth="lg"
				sx={{
					position: 'relative'
				}}
			>
				<Box textAlign="center">
					<Typography
						variant={mdDown ? 'h2' : 'lead'}
						fontSize={{
							xs: 28,
							md: 62
						}}
						fontWeight={mdDown ? 'regular' : 'bold'}
						sx={{
							display: 'block',
							mb: 1
						}}
					>
						{t('pricing.hero.title', { siteName: SITE_NAME })}
					</Typography>
					<Typography
						variant={mdDown ? 'body2' : 'body3'}
						color="text.secondary"
					>
						{t('pricing.hero.subheading')}
					</Typography>
				</Box>

				<Stack
					alignItems={{
						xs: 'center',
						md: 'flex-start'
					}}
					justifyContent="center"
					direction={{
						xs: 'column',
						md: 'row'
					}}
					mt={{
						xs: 2,
						md: showCurrencySelector ? 5 : 2
					}}
					pt={{ xs: 2, md: 4 }}
					sx={{
						'& > *': {
							flex: 1,
							width: {
								xs: '100%',
								md: 'auto'
							}
						}
					}}
					spacing={{
						xs: 0,
						md: 3
					}}
					useFlexGap
				>
					<PlanCardUnified plansData={plansData} />
				</Stack>
			</Container>
		</Box>
	);
}
